import { createModalStore } from '@/shared/lib/modal';

type TrialPricingModalData = {
  openedAutomatically: boolean;
};

export const useTrialPricingModalStore = createModalStore<TrialPricingModalData>({ openedAutomatically: false }, false);
